/**
 * Calcula a média final a ser enviada ao Sponte a partir dos campos
 * MB, RM e RB de uma nota.
 *
 * Regra:
 *  - Considerar apenas valores numéricos > 0
 *  - Usar o maior valor entre MB, RM e RB
 *  - Arredondar para 1 casa decimal (Math.round(x * 10) / 10)
 *  - Formatar com vírgula como separador decimal e sempre 1 casa: "6,4"
 *  - Se não houver valor válido, retornar string vazia
 *
 * @param {Object} grade - Objeto de nota com possíveis campos mb, rm, rb (strings)
 * @returns {string} média final formatada ou "" se não houver valor válido
 */
export const calculateFinalAverageForSponte = (grade) => {
  if (!grade) return "";

  const mbValue = grade.mb ? parseFloat(grade.mb.replace(",", ".")) : 0;
  const rmValue = grade.rm ? parseFloat(grade.rm.replace(",", ".")) : 0;
  const rbValue = grade.rb ? parseFloat(grade.rb.replace(",", ".")) : 0;

  let bestValue = 0;

  if (!isNaN(mbValue) && mbValue > 0) bestValue = mbValue;
  if (!isNaN(rmValue) && rmValue > 0 && rmValue > bestValue) bestValue = rmValue;
  if (!isNaN(rbValue) && rbValue > 0 && rbValue > bestValue) bestValue = rbValue;

  if (bestValue <= 0) {
    return "";
  }

  const roundedValue = Math.round(bestValue * 10) / 10;
  return roundedValue.toFixed(1).replace(".", ",");
};








